module.exports = __webpack_public_path__ + "img/qnbfinans.e3024f98.png";